function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "var(--k-fg-0d53fc)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5965 21.1956L14.3201 20.6428H13.702H9.724C9.32555 20.6428 9 20.3172 9 19.9189V10.724C9 10.3256 9.3256 10 9.724 10H21.2761H22.2761C22.6744 10 23 10.3256 23 10.724V19.9189C23 20.3173 22.6743 20.6429 22.2761 20.6429H18.2981H17.6801L17.4037 21.1957L16.0862 23.8305L16.0862 23.8305C16.0541 23.8947 16.0237 23.9377 16 23.9655C15.9763 23.9377 15.9459 23.8947 15.9138 23.8305C15.9138 23.8305 15.9138 23.8305 15.9138 23.8305L14.5965 21.1956Z",
  fill: "var(--k-fg-0d53fc)",
  stroke: "white",
  strokeWidth: 2
});

function SvgCommentPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentPrimary);
export default __webpack_public_path__ + "static/media/comment_primary.e5426667.svg";
export { ForwardRef as ReactComponent };